// extracted by mini-css-extract-plugin
export default {"formHeading":"MG-z","form":"NG-z","submitBtn":"OG-z","disabled":"PG-z","input":"QG-z","error":"RG-z","submitMsg":"SG-z","signIn":"TG-z"};